<!-- 用户行为明细 -->
<template>
  <div class="behaviorDetail">
    <div class="query-bar">
      <div class="query-left">
        <el-form inline>
          <el-form-item label="行为类型:">
            <el-select
              v-model="filter_behavior_type"
              placeholder="请选择"
              no-data-text="加载中"
              :clearable="true"
            >
              <el-option
                v-for="item in options_behavior_type"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份类型:">
            <el-select
              v-model="filter_user_type"
              placeholder="请选择"
              no-data-text="加载中"
              :clearable="true"
            >
              <el-option
                v-for="item in options_user_type"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择日期:">
            <el-date-picker
              :value="filter_date"
              @input="datePickerHandler"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="query-right">
        <el-button type="primary" @click="handleSureClick">筛选</el-button>
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          :config-name="$options.name"
          :excel-data="excelData"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="user_name" label="姓名"></el-table-column>
        <el-table-column prop="user_id" label="编号"></el-table-column>
        <el-table-column prop="user_type" label="身份"></el-table-column>
        <el-table-column prop="behavior_time" label="时间"></el-table-column>
        <el-table-column prop="behavior_type" label="行为"></el-table-column>
        <el-table-column prop="target_name" label="对象"></el-table-column>
        <el-table-column prop="related_username" label="关联用户"></el-table-column>
        <div slot="empty"><NoData></NoData></div>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  //   GetUserStatPages,
  GetUserBehaviorList,
  GetKvList,
} from '@/api/dataCenter.js';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
import cloneDeep from 'lodash/cloneDeep';
import { minxinTable } from '../../mixin/table.js';
export default {
  name: 'BehaviorDetail',
  components: { NoData, ExportExcel, ExportProgress },
  mixins: [minxinTable],
  props: {},
  data() {
    return {
      options_behavior_type: [],
      options_user_type: [],
      filter_behavior_type: '',
      filter_user_type: '',
      filter_date: [],
      excelData: [],
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  async created() {
    this.loading = true;
    await this.getBehaviorTypeList();
    await this.getUserTypeList();
    await this.getTableData();
    this.loading = false;
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    datePickerHandler(val) {
      this.filter_date = val;
    },
    /** 获取表格数据
     * @param {Object} val 参数
     * @param {Boolean} isExportExcel 是否导出
     * @return {void}
     */
    async getTableData(val = {}, isExportExcel = false) {
      this.loading = true;
      const { startTime, endTime } = this.toTimeStamp();
      if (isExportExcel) {
        this.$refs.downloadDialog.openDialog();
        this.$refs.downloadDialog.startRidiculousProgress(30);
      }
      const query = {
        behavior_type: +this.filter_behavior_type || undefined, // 行为类型
        user_type: this.filter_user_type || undefined, // 用户身份类型
        start_time: startTime, // 开始时间戳
        end_time: endTime, // 结束时间戳
        page_index: this.currentPage, // 页码
        page_size: this.pageSize, // 默认每页20条
        ...val,
      };
      try {
        if (isExportExcel) {
          const res = await GetUserBehaviorList({
            ...query,
            page_size: 1,
            page_index: 1,
          });
          if (res.total_num > 50000) {
            this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
            this.$refs.downloadDialog.abortProgress();
            this.loading = false;
            return;
          }
        }
        const res = await GetUserBehaviorList(query);
        console.log('导出的全部的条数', res.total_num);

        const resTemp = res.data.reduce((arr, item, index) => {
          // 时间
          item.behavior_time = this.toFormat(item.behavior_time);

          // 行为类型
          item.behavior_type = this.mapBehaviorType(item) ? this.mapBehaviorType(item).value : '';

          // 身份类型
          item.user_type = this.mapBUserType(item) ? this.mapBUserType(item).value : '';

          arr[index] = item;
          return arr;
        }, []);

        if (isExportExcel) {
          this.excelData = resTemp;
          this.$refs.downloadDialog.finishProgress(500);
        } else {
          this.tableData = resTemp;
        }
        // isExportExcel ? (this.excelData = resTemp) : (this.tableData = resTemp);
        this.total = res.total_num;
      } catch (error) {
        this.$message(error.message);
        this.$refs.downloadDialog.abortProgress();
        this.loading = false;
      }
      this.loading = false;
    },
    // 筛选
    handleSureClick() {
      const { startTime, endTime } = this.toTimeStamp();
      this.currentPage = 1;
      this.getTableData({
        start_time: startTime,
        end_time: endTime,
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      const { startTime, endTime } = this.toTimeStamp();
      this.getTableData({
        start_time: startTime,
        end_time: endTime,
      });
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.pageSize = e;
      const { startTime, endTime } = this.toTimeStamp();
      this.getTableData({
        start_time: startTime,
        end_time: endTime,
      });
    },
    // 导出表格数据
    handleExportExcel() {
      const query = {
        page_index: 1,
        page_size: 99999,
      };
      this.getTableData(query, true);
    },
    // 行为类型
    getBehaviorTypeList() {
      return new Promise((resolve) => {
        GetKvList({ type: 'behavior_type' }).then((res) => {
          this.options_behavior_type = res.list;
          resolve(true);
        });
      });
    },
    // 映射行为类型
    mapBehaviorType(item) {
      const behaviorTypeItem = this.options_behavior_type.find(
        (e) => +e.key === item.behavior_type,
      );
      return behaviorTypeItem;
    },
    // 身份类型
    getUserTypeList() {
      return new Promise((resolve) => {
        GetKvList({ type: 'user_type' }).then((res) => {
          this.options_user_type = res.list;
          resolve(true);
        });
      });
    },
    // 映射身份类型
    mapBUserType(item) {
      const userTypeList = cloneDeep(this.options_user_type);
      userTypeList.push({
        key: 'representative',
        value: '代表',
      });
      const userTypeItem = userTypeList.find((e) => e.key === item.user_type);
      return userTypeItem;
    },
  },
};
</script>
<style lang="scss" scoped>
.behaviorDetail {
  .query-bar {
    .query-left {
      display: inline-block;
    }
    .query-right {
      float: right;
    }
  }
  .content {
    .pagination {
      float: right;
    }
  }
}
</style>
